module.exports = __webpack_public_path__ + "static/media/comment2_1.3ea92b98.png";